import PropTypes from "prop-types";

import SectionSeparator from "@/directory/SectionSeparator";
import { headingCss, descriptionCss } from "./SectionTitle.style";

const propTypes = {
  children: PropTypes.string.isRequired,
  description: PropTypes.string,
  separator: PropTypes.bool,
  __css: PropTypes.object,
  isContentSettingsPage: PropTypes.bool,
};

const defaultProps = {
  isContentSettingsPage: false,
};

const SectionTitle = ({
  children,
  description,
  separator,
  __css,
  isContentSettingsPage,
}) => {
  return (
    <div css={__css}>
      {separator && <SectionSeparator />}
      <h2 css={headingCss(isContentSettingsPage)}>{children}</h2>
      {description && (
        <p css={descriptionCss(isContentSettingsPage)}>{description}</p>
      )}
    </div>
  );
};

SectionTitle.propTypes = propTypes;
SectionTitle.defaultProps = defaultProps;

export default SectionTitle;
